<template>
    <div class="card">
        <div class="card-body">
            <div class="center-container">
                <div class="left-content">
                    <h3>
                        <b>{{trans('step1.booking_details','BOOKING DETAILS')}}</b>
                        <a v-if="editing_allowed" class="pull-right" data-toggle="modal" href="#location-modal">
                            <i class="fa fa-pencil"></i>
                        </a>
                    </h3>
                    <h4 class="m-t-10 resort-name" style="display: inline-flex;align-items: center;">
                                    <span class="pull-right">
                                        <i class="fa fa-map-marker" style="margin-left:2px"></i>
                                        &nbsp;&nbsp;<span style="margin-left:5px">{{ getResortName }}</span>
                                    </span>
                    </h4>
                    <h4 class="m-t-10 text-center">
                                <span class="pull-left">
                                    <i class="fa fa-clock-o"></i>
                                    &nbsp;&nbsp;<span style="margin-left:1px">{{ form.delivery_date }}</span>
                                </span>
                        <span> @ </span>
                        <span class="pull-right">{{ form.delivery_time}}</span>
                    </h4>
                    <h4 class="m-t-10 text-center">
                                    <span class="pull-left">
                                        <i class="fa fa-calendar"></i>
                                        &nbsp;&nbsp;<span>{{ form.first_day_skiing }}</span>
                                    </span>
                        <span> - </span>
                        <span class="pull-right">{{ form.return_date }}</span>
                    </h4>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
import {mapState, mapGetters} from "vuex";
export default {
    name: 'ShortDeliveryDetail',
    props:{'editing_allowed': true},
    computed: {
        ...mapState(['form']),
        ...mapGetters(['getResortName'])
    },
    methods: {
        trans(key, defaultValue, msg = null) {
            let translation = '';
            if (msg) {
                translation = this.$t(key, {message: msg});
            } else {
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
    }
}
</script>
